import {BaseRemoteConfiguration} from "../../infrastructure/models/base-remote-configuration";

export const SCORES_BAR_WIDGET_REMOTE_CONFIG = {
}

export class ScoresBarWidgetRemoteConfig extends BaseRemoteConfiguration {
  get defaultConfig() {
    return Object.values(SCORES_BAR_WIDGET_REMOTE_CONFIG);
  }
}